import { render, staticRenderFns } from "./PwaHistory.vue?vue&type=template&id=0a7b0c56&scoped=true"
import script from "./PwaHistory.vue?vue&type=script&lang=js"
export * from "./PwaHistory.vue?vue&type=script&lang=js"
import style0 from "./PwaHistory.vue?vue&type=style&index=0&id=0a7b0c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b0c56",
  null
  
)

export default component.exports